import { ClientQuoteApi } from './clientQuoteApi';
import {
  getDefaultWorkshopAddress,
} from '../../../shared/utils/maintenanceTypeHelpers';

function formatCatalog(service) {
  return {
    id: service.id,
    nome: service.nome,
    categoria: service.categoria,
    descricao: service.descricao,
    precoBase: service.preco_base
  };
}

function formatCatalogList(data) {
  return data.map(service => formatCatalog(service));
}

function formatQuotationItem(item) {
  return {
    id: item.servicoId,
    nome: item.nome,
    observacoes: item.observations,
    quantidade: item.quantity,
    modelo: item.model,
    marca: item.brand,
    problema: item.problem
  };
}

function formatServicoTask(task) {
  return {
    id: task.id,
    nome: task.nome,
    valor: task.valor
  };
}

function formatQuotationRequest(data) {
  return {
    tipo: 'cotacao',

    servicos: data.servicos || [],
    endereco: data.endereco || getDefaultWorkshopAddress(),
    observacoes_gerais: data.observacoes || '',
    quantity: data.quantity || 1,
    model: data.model || '',
    brand: data.brand || '',
    problem: data.problem || '',
    maintenanceLocalization: data.maintenanceLocalization || 'oficina',
    // Enviar estrutura completa {id, nome} para o campo 'equipamentos' do DTO
    equipamentos: data.equipamentos || [],
    // Manter equipmentIds legado com apenas IDs se necessário, ou extrair dos objetos
    equipmentIds: data.equipamentos ? data.equipamentos.map(e => e.id) : (data.equipmentIds || [])
  };
}

function getEquipmentsCatalog() {
  return ClientQuoteApi.getEquipmentsCatalog()
    .then(response => formatCatalogList(response.data));
}

function createQuotation(quotationData) {
  const requestData = formatQuotationRequest(quotationData);
  return ClientQuoteApi.createQuotation(requestData)
    .then(response => response.data);
}

function getQuotationStatus(clienteSlug, dominio, origemPk) {
  return ClientQuoteApi.getQuotationStatus(clienteSlug, dominio, origemPk)
    .then(response => response.data);
}

function formatTask(service) {
  return {
    id: service.id,
    codigo: service.codigo_servico,
    descricao: service.descricao,
    valor: service.valor
  };
}

function formatTaskList(data) {
  return data.map(formatTask);
}

function getCatalogServices() {
  return ClientQuoteApi.getCatalogServices()
    .then(response => formatTaskList(response.data));
}

export const ClientQuoteService = {
  getEquipmentsCatalog,
  createQuotation,
  getQuotationStatus,
  getCatalogServices,
  formatCatalog,
  formatCatalogList,
  formatQuotationItem,
  formatQuotationRequest,
  formatServicoTask
};
